import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import api from "../Axios";

const AdminProfile = () => {
  const [data, setData] = useState("");

  useEffect(() => {
    api
      .get("/admin/auth/viewProfile")
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        // handle error if needed
      });
  }, []);

  return (
    <div className="content " style={{ padding: "20px" ,marginTop:"100px"}}>
      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={6}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              padding: "30px",
              maxWidth: "1000px",
              margin: "0 auto",
            }}
          >
            <h4
              style={{
                fontSize: "22px",
                fontWeight: "600",
                marginBottom: "20px",
                color: "#2c3e50",
                textAlign: "center",
                borderBottom: "1px solid #eee",
                paddingBottom: "10px",
              }}
            >
              Admin Profile
            </h4>

            <div>
              <h5
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  textTransform: "capitalize",
                  marginBottom: "12px",
                  color: "#333",
                }}
              >
                {data.username || "Loading..."}
              </h5>

              <div
                style={{ fontSize: "15px", color: "#555", lineHeight: "1.8" }}
              >
                <p>
                  <strong>Email:</strong> {data.email}
                </p>
                <p>
                  <strong>Phone:</strong> {data.phone}
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AdminProfile;
